import styled from 'styled-components';

export const Field = styled.div`
  position: relative;
  margin: 0 0 20px;
`;
